import app from "./app";

var store = {
  users: {
    get(id) {
      return app.api.child(`users/${id}`).get();
    },
    signIn() {
      return app.api.child('me/sign_in').post();
    },
    index({limit, offset=0, role=''}={}) {
      return app.api.child('users').get({limit, offset, role});
    }
  }
}

export default store;